import { object, string } from 'yup';
import { email } from 'app/constants/regex';

export const schema = object().shape({
  surname: string().required(),
  name: string().required(),
  fname: string().required(),
  fin: string().required(),
  email: string().matches(email).required(),
  phone: string().required(),
  position: string(),
  rules: string(),
});
